/*
 * This file is part of the Akershus Eiendom Nettsted 2019 application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Form from 'components/Form/Form';
import './Default.scss';

/**
 * This is the Default component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function Default({
  formRef,
  id,
  route,
  className,
  title,
  form,
  onMount,
  ...props
}) {
  useEffect(onMount, []);

  function renderTitle() {
    if (!title) return null;

    if (typeof title === 'object') {
      if (route && title[route]) {
        return <h3 dangerouslySetInnerHTML={{ __html: title[route] }} />;
      }
      if (title.default) {
        return <h3 dangerouslySetInnerHTML={{ __html: title.default }} />;
      }
    }

    if (typeof title === 'string') {
      return <h3 dangerouslySetInnerHTML={{ __html: title }} />;
    }

    return null;
  }

  return (
    <div className={classnames('step step-default', className)}>
      {renderTitle()}
      <Form ref={formRef} {...form} {...props} />
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
Default.propTypes = {
  id: PropTypes.string,
  route: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  form: PropTypes.object.isRequired,
  onMount: PropTypes.func.isRequired,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
Default.defaultProps = {
  form: {},
  onMount: () => {},
};

export default React.forwardRef((props, ref) => (
  <Default {...props} formRef={ref} />
));
